<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

export default {
    name: 'App',
    created () {
    }
};
</script>

<style lang="less">
@import './styles/common.less';

#app {
    text-align: left;
    height: 100%;
    max-width: 100%;
    margin: 0 auto;
    overflow-x: hidden;
    background: #f8fafc;
}
.robot-avatar {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  vertical-align: middle;
  object-fit: cover;
  border: 2px solid #e2e8f0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: block;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }
}
html,
body {
    margin: 0;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial,"PingFang SC","Microsoft YaHei","Noto Sans",sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    background: #f8fafc;
    color: #1e293b;
}
a {
    color: #3b82f6;
}

/* 滚动条样式 */
::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    #app {
        padding: 0;
    }
    .robot-avatar {
        height: 28px;
        width: 28px;
        border-width: 1px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    }
}
</style>
